// Zeno — PDP "Popular add-ons" module.
// Fetches Shopify's own complementary-product recommendations
// asynchronously (same lazy-load-on-scroll pattern Dawn uses for its
// own related-products section) and wires a quick add-to-cart button
// per card. The add-to-cart POST mirrors zeno-sticky-atc.js's approach
// (cart/add.js with sections param, patch cart-drawer + cart-icon-bubble
// in place) so both quick-add paths behave identically.
class ZenoPdpAddons extends HTMLElement {
  connectedCallback() {
    this.initRecommendations();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  initRecommendations() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('zeno-pdp-addons');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          } else {
            this.remove();
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }

  handleClick(event) {
    const button = event.target.closest('[data-zeno-addon-add]');
    if (!button) return;
    event.preventDefault();
    if (button.classList.contains('is-added') || button.disabled) return;

    const variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    const originalText = button.textContent;
    button.textContent = 'Adding\u2026';
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.sections) {
          if (data.sections['cart-drawer']) {
            const existingDrawer = document.querySelector('cart-drawer');
            if (existingDrawer) {
              const temp = document.createElement('div');
              temp.innerHTML = data.sections['cart-drawer'];
              const newDrawer = temp.querySelector('cart-drawer');
              if (newDrawer) existingDrawer.replaceWith(newDrawer);
            }
          }
          if (data.sections['cart-icon-bubble']) {
            const bubble = document.getElementById('cart-icon-bubble');
            if (bubble) {
              const temp = document.createElement('div');
              temp.innerHTML = data.sections['cart-icon-bubble'];
              const newBubble = temp.querySelector('#cart-icon-bubble');
              if (newBubble) bubble.replaceWith(newBubble);
            }
          }
        }

        button.textContent = 'Added';
        button.classList.add('is-added');

        const cartDrawerEl = document.querySelector('cart-drawer');
        if (cartDrawerEl && typeof cartDrawerEl.open === 'function') {
          cartDrawerEl.open();
        }
      })
      .catch((error) => {
        console.error(error);
        button.textContent = originalText;
        button.disabled = false;
      });
  }
}

customElements.define('zeno-pdp-addons', ZenoPdpAddons);
